import { Navigate, useLocation } from "react-router-dom";

export default function MembershipIndexPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/overview`} replace />;
}
